import { useContext } from 'react';
import { DocumentWorkflowContract } from '@dealstack/frontend/investor/pages/Investment/common/DocumentWorkflowContracts/DocumentWorkflowContract';
import { investmentJoinAndAllocationContext } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/InvestmentJoinAndAllocation';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';

export const JoinAndAllocationContracts = () => {
	const { setIsContinueDisabled, dealId, mipId, investorId } = useContext(
		investmentJoinAndAllocationContext
	);
	const { investmentWorkflowId } = useRequiredParams('investmentWorkflowId');

	if (!investorId) {
		return null;
	}

	return (
		<DocumentWorkflowContract
			setIsContinueDisabled={setIsContinueDisabled}
			dealId={dealId}
			mipId={mipId}
			investorId={investorId}
			investmentWorkflowId={investmentWorkflowId}
			excludeTsaContracts={false}
		/>
	);
};
